<template>
    <div class="d-flex flex-nowrap align-center justify-center">
        <v-text-field :label="label" v-model="display" @click="edit" readonly :rules="getRules()" :dense="dense" />

        <v-dialog v-model="dialog" max-width="1000px" :key="refreshKey">
            <v-form ref="editForm" @submit="onSave" @submit.prevent>
                <v-card>
                    <v-card-title>
                        <span class="headline">Choose Coordinate</span>
                    </v-card-title>

                    <v-card-text>
                        <v-text-field v-model="latitude" @change="moveMarker()" label="Latitude" />
                        <v-text-field v-model="longitude" @change="moveMarker()" label="Longitude" />
                        <div style="overflow:hidden;z-index:-999;">
                            <div id="map" />
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="quinary" text @click="onDelete" :disabled="readonly">Clear</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="quaternary" text @click="closeDialog">Cancel</v-btn>
                        <v-btn type="submit" color="quaternary" text :disabled="readonly">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    const google = window.google

    export default {
        props: [
            'value',
            'label',
            'readonly',
            'rules',
            'dense'
        ],

        data() {
            return {
                coordinates: null,
                map: null,
                infoWindow: null,
                loading: false,
                dialog: false,
                editedItem: null,
                display: null,
                isClicked: false,
                refreshKey: 0,
                browserLocation: new google.maps.LatLng(-31.95, 115.86),
                latitude: -31.95,
                longitude: 115.86
            };
        },

        mounted() {
            this.setDisplay(this.value);
        },

        methods: {
            load() {
                this.coordinates = this.value;
                if (navigator.geolocation) {
                    var self = this;
                    navigator.geolocation.getCurrentPosition(position => {
                        self.browserLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        self.latitude = position.coords.latitude;
                        self.longitude = position.coords.longitude;
                        self.setMapPosition();
                    }, positionError => {
                        positionError;
                        self.setMapPosition();
                    });
                }

            },
            setMapPosition() {
                var startCoordinates = !this.coordinates ? this.browserLocation : new google.maps.LatLng(this.round(this.coordinates.latitude, 4), this.round(this.coordinates.longitude, 4));

                var options = {
                    zoom: 10,
                    center: startCoordinates,
                    gestureHandling: 'greedy'
                };

                var div = document.getElementById('map');
                this.map = new google.maps.Map(div, options);

                var content = "";
                if (!this.coordinates) {
                    content = 'Click the map to choose a coordinate';
                }
                else {
                    content = this.displayCoordinates(this.coordinates.latitude, this.coordinates.longitude);
                }
                this.infoWindow = new google.maps.InfoWindow(
                    { content: content, position: startCoordinates });
                this.infoWindow.open(this.map);

                var self = this;
                // Configure the click listener.
                this.map.addListener('click', (mapsMouseEvent) => self.openInfoWindow(mapsMouseEvent));
            },
            moveMarker() {
                var latLng = new google.maps.LatLng(this.latitude, this.longitude);
                this.map.setCenter(latLng);

                this.infoWindow.close();

                this.coordinates = { latitude: this.latitude, longitude: this.longitude };

                // Create a new InfoWindow.
                this.infoWindow = new google.maps.InfoWindow({ position: latLng });
                this.infoWindow.setContent(this.latitude + ", " + this.longitude);
                this.infoWindow.open(this.map);
            },
            openInfoWindow(mapsMouseEvent) {
                // Close the current InfoWindow.
                this.infoWindow.close();

                this.latitude = mapsMouseEvent.latLng.lat();
                this.longitude = mapsMouseEvent.latLng.lng();
                this.coordinates = { latitude: this.latitude, longitude: this.longitude };

                // Create a new InfoWindow.
                this.infoWindow = new google.maps.InfoWindow({ position: mapsMouseEvent.latLng });
                this.infoWindow.setContent(this.displayCoordinates(mapsMouseEvent.latLng.lat(), mapsMouseEvent.latLng.lng()));
                this.infoWindow.open(this.map);
            },
            round(number, decimalPlaces) {
                return Math.round((number + Number.EPSILON) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
            },
            edit() {
                if (this.readonly) { return; }
                this.isClicked = true;
                this.refreshKey++;
                this.dialog = true;
                setTimeout(this.load, 10);
            },
            onSave() {
                this.setDisplay(this.coordinates);
                this.$emit('input', this.coordinates);
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
            getRules() {
                if (this.isClicked) {
                    return this.rules;
                }
                return [];
            },
            onDelete() {
                this.display = "";
                this.$emit('input', null);
                this.closeDialog();
            },
            displayCoordinates(lat, lng) {
                return this.round(lat, 4) + ", " + this.round(lng, 4);
            },
            setDisplay(value) {
                this.display = value ? "(" + this.displayCoordinates(value.latitude, value.longitude) + ")" : "";
            }
        },
        watch: {
            value() {
                this.setDisplay(this.value);
            },
        }
    };
</script>

<style>
    #map {
        width: 100%;
        height: 50vh;
    }
</style>
